import axios from 'axios';
import { createRoot } from 'react-dom/client';
import { Snackbar, Alert } from '@mui/material';
import { authService } from './authService';

// Create a container for the toast
const toastContainer = document.createElement('div');
document.body.appendChild(toastContainer);
const root = createRoot(toastContainer);

// Toast function
const showToast = (message, severity) => {
    root.render(
      <Snackbar
        open={true}
        autoHideDuration={3000}
        onClose={() => root.render(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{ 
          zIndex: 9999,
          position: 'fixed',
          top: 16,
          right: 16
        }}
      >
        <Alert severity={severity} sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    );
  };
  

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    showToast('Error in request', 'error');
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.config.method !== 'get') {
      showToast('Operation successful', 'success');
    }
    return response;
  },
  (error) => {
    showToast(error.response?.data?.message || 'Operation failed', 'error');
    return Promise.reject(error);
  }
);

export default axiosInstance;
